'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './custom-edit.routes';
var pluralize = require('pluralize');

export class CustomEditComponent {
  constructor(Auth, $state, dialogs, $filter, $stateParams, $uibModal, CustomEntityService, $scope, $location,
              SettingsService, PropertyService, ContactService, CommunityService, User, $timeout, VendorService) {
    'ngInject';
    this.CustomEntityService = CustomEntityService;
    this.PropertyService = PropertyService;
    this.ContactService = ContactService;
    this.VendorService = VendorService;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$scope = $scope;
    this.entityId = $stateParams.id;
    this.model = {};
    this.$filter = $filter;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;

    this.type = $stateParams.type;
    this.dehyphendType = this.type.replace(/-/g," ");

    var getCustomEntityName = function (entity, nameParts) {
      let arrayNameParts = Array.isArray(nameParts) ? nameParts : [nameParts];

      let name = [];

      arrayNameParts.forEach(np => {
        if (np.startsWith("$")) {
          let dataKey = np.substring(1).trim();
          name.push(entity.data[dataKey]);
        } else {
          name.push(np);
        }
      });

      return name.join('');

    };

    SettingsService.getByName({name: 'custom-entities'}, settings => {
      this.schema = settings.data.entitySchema[this.type];
      this.listConfig = settings.data.entityList[this.type];

      this.count = 0;
      this.maxCount = 6;

      let fnReady = _ => {
        let keys = Object.keys(this.schema.properties);
        keys.forEach(key => {
          if (this.schema.properties[key].hasOwnProperty("x-schema-form")) {
            let ref = this.schema.properties[key]["x-schema-form"];
            if (ref.type === 'entitylookup') {

              switch (ref.lookuptype) {
                case 'property':
                  this.schema.properties[key]["entityLookupData"] = this.propertyData;
                  this.schema.properties[key]["fnLookup"] = (key) => {
                    this.propertyLookup(key);
                  };
                  break;
                case 'user':
                  this.schema.properties[key]["entityLookupData"] = this.userData;
                  this.schema.properties[key]["fnLookup"] = (key) => {
                    this.userLookup(key);
                  };
                  break;
                case 'contact':
                  this.schema.properties[key]["entityLookupData"] = this.contactData;
                  this.schema.properties[key]["fnLookup"] = (key) => {
                    this.contactLookup(key);
                  };
                  break;
                case 'community':
                  this.schema.properties[key]["entityLookupData"] = this.communityData;
                  this.schema.properties[key]["fnLookup"] = (key) => {
                    this.communityLookup(key);
                  };
                  break;
                case 'vendor':
                  this.schema.properties[key]["entityLookupData"] = this.vendorData;
                  this.schema.properties[key]["fnLookup"] = (key) => {
                    this.vendorLookup(key);
                  };
                  break;
                case 'entity':
                  this.schema.properties[key]["entityLookupData"] = this.customEntityData.filter(entity => entity.group == ref.config.entityType);
                  this.schema.properties[key]["fnLookup"] = (key) => {
                    this.customEntityLookup(key, ref.config);
                  };
                  break;
              }

            }

          }
        });

        // load object data
        if (this.entityId) {
          this.CustomEntityService.get({id: this.entityId}, entity => {    //TODO: getPublicByName
            this.form = ["*"];
            this.entity = entity;
            this.model = this.entity.data;

            // Make the date string fields real date object for the datepicker to work
            // TODO: does only work for flat objects, and not nested properties (must be recursive)
            Object.keys(this.schema.properties).forEach(key => {
              if (this.schema.properties[key].type == 'string' && this.schema.properties[key].format == 'date') {
                if (this.model[key]) {
                  this.model[key] = new Date(this.model[key]);
                }
              }
            });

            this.$scope.$broadcast('schemaFormRedraw');
          }, _ => {
            console.log("Could not load e-form schema from server");
            this.formNotFound = true;
          });
        }
      };

      PropertyService.query(data => {
        this.propertyData = data.filter(entity => !!entity.address).map(entity => {
          return {
            value: entity._id,
            name: entity.address.street + ", " + entity.address.city + ", " + entity.address.state + ", " + entity.address.zip,
            group: entity.community.name
          }
        });

        this.count++;
        if (this.count == this.maxCount)
          fnReady();
      });

        ContactService.query(data => {
          this.contactData = data.map(entity => {
            return {
              value: entity._id,
              name: this.getComposedName(entity),
              group: "General"
            }
          });

          this.count++;
          if (this.count == this.maxCount)
            fnReady();
        });

        CommunityService.query(data => {
          this.communityData = data.map(entity => {
            return {
              value: entity._id,
              name: entity.code + ": " + entity.name,
              group: "General"
            }
          });

          this.count++;
          if (this.count == this.maxCount)
            fnReady();
        });

      VendorService.query(data => {
        this.vendorData = data.map(entity => {
          return {
            value: entity._id,
            name: entity.name,
            group: entity.businessType
          }
        });

        this.count++;
        if (this.count == this.maxCount)
          fnReady();
      });

      CustomEntityService.query(data => {
        this.customEntityData = data.map(entity => {

          let field = this.listConfig.find(f => f.entityType && f.entityType == entity.schemaSettings);
          let name = getCustomEntityName(entity, (field && field.nameBuilder) ? field.nameBuilder : 'Entity');

          return {
            value: entity._id,
            name: name,
            group: entity.schemaSettings
          }
        });

        this.count++;
        if (this.count == this.maxCount)
          fnReady();
      });

        User.query(users => {
          this.userData = users.map(user => {
            return {
              value: user._id,
              name: user.shortName,
              group: 'General'
            }
          });

          this.count++;
          if (this.count == this.maxCount)
            fnReady();
        });

    });

    this.entity = {
      schemaSettings: this.type,
      data: {}
    };

    this.isLoggedIn = Auth.isLoggedInSync();
    this.user = Auth.getCurrentUserSync();
  }

  contactLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'contactLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (contact) {
        that.model[key] = contact._id;
      },
      function () { /* cancel */ }
    );

  }

  userLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'userLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (user) {
        that.model[key] = user._id;
      },
      function () { /* cancel */ }
    );

  }

  propertyLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'propertyLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (property) {
        that.model[key] = property._id;
      },
      function () { /* cancel */ }
    );

  }

  communityLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'communityLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (community) {
        that.model[key] = community._id;
      },
      function () { /* cancel */ }
    );

  }

  vendorLookup(key) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'vendorLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (vendor) {
        that.model[key] =  vendor._id;
      },
      function () { /* cancel */ }
    );

  }

  customEntityLookup(key, config) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'customEntityLookup',
      resolve: {
        config: function() {
          return config
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (entity) {
        that.model[key] =  entity._id;
      },
      function () { /* cancel */ }
    );

  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  pluralize(word) {
    return pluralize(word, 2);
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    // First we broadcast an event so all fields validate themselves
    this.$scope.$broadcast('schemaFormValidate');

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.entityId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The entity has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$location.url("/custom/"+this.type+"/list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.entity.data = this.model;

      if (!this.entityId) {
        this.CustomEntityService.save(this.entity, onSuccess, onError);
      } else {
        this.CustomEntityService.update({id: this.entityId}, this.entity, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.customEdit', [uiRouter])
  .config(routes)
  .component('customEdit', {
    template: require('./custom-edit.html'),
    controller: CustomEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/custom/edit/custom-edit.component.js